// SSR (uses an empty object)
let windowObj = {
  open: (url: string) => {},
  location: {
    reload: () => {},
    href: '',
  },
  printData: undefined,
  print: () => {},
  addEventListener: (event: string, cb: (event: any) => void) => {},
  document: {
    querySelector: (selector: string): any => {},
  },
  scrollTo: (x: number, y: number) => {},
}

// Browser rendering
export function initWindowObject() {
  windowObj = window
}

export const getWindowObject = () => windowObj
